var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    }
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { EventEmitter } from "@angular/core";
import { ITSImage } from "../itsImage.model";
import { LanguageUtil } from "../language.model";
var Media = /** @class */ (function () {
    function Media(language, posterImage, downloadGenerateURL) {
        this.language = language;
        this.posterImage = posterImage;
        this.downloadGenerateURL = downloadGenerateURL;
        this.isAvailable = true;
        /*
         Raises event when URS geo-restriction result is evaluated.
         If Media is not geo-restricted, this does not raise an event.
         */
        this.geoRestrictionEvaluated = new EventEmitter();
    }
    Media.prototype.hasTranscript = function () {
        return false;
    };
    Media.prototype.isGeoRestrictionEvaluated = function () {
        return true;
    };
    Media.prototype.isAvailableToUser = function () {
        return this.isGeoRestrictionEvaluated() && this.isAvailable;
    };
    Media.prototype.evaluateURSRestriction = function (usrService) {
        var _this = this;
        if (this.isGeoRestrictionEvaluated()) {
            return;
        }
        var checkedURL = this.getGeoRestrictedCheckURL();
        usrService.evaluateURSRestriction(checkedURL).subscribe(function (response) {
            if (response.error) {
                _this.setGeoRestrictionResponse(checkedURL, null, response.error);
            }
            else {
                _this.setGeoRestrictionResponse(checkedURL, response.url, null);
            }
            _this.geoRestrictionEvaluated.emit(_this);
        });
    };
    Media.prototype.setGeoRestrictionResponse = function (checkedURL, url, errorCode) { };
    Media.prototype.getGeoRestrictedCheckURL = function () {
        return null;
    };
    Media.prototype.getDefaultPosterImage = function () {
        return this.posterImage.itsURL;
    };
    Media.fromData = function (data) {
        var image = new ITSImage(data.poster_image.url, data.poster_image.alt_text);
        var language = LanguageUtil.fromStringCode(data.language);
        var captions = (data.captions || []).map(function (c) { return new Caption(c.url, LanguageUtil.fromStringCode(c.language)); });
        if (data.type === "video") {
            return new VideoMedia(language, image, data.download_url, data.transcript_print_url, data.transcript_text, data.transcript_url, captions, (data.files || []).map(function (fileData) {
                return VideoMediaFile.fromData(fileData);
            }), !!data.is_360_video, data.chapters_url);
        }
        else if (data.type === "image") {
            return new ImageMedia(language, image, data.download_url, data.file_url, data.image_description, data.canonical_url);
        }
        else if (data.type === "document") {
            return new DocumentMedia(language, image, data.download_url, data.document_url);
        }
        else if (data.type === "interactive") {
            return new InteractiveMedia(language, image, data.download_url, data.type, data.file_url, data.canonical_url, data.show_flash_warning);
        }
        else if (data.type === "pointer") {
            return new PointerMedia(language, image, data.download_url, data.type, data.file_url, data.canonical_url, data.show_flash_warning);
        }
        else if (data.type === "lti") {
            return new LTIMedia(language, image, data.download_url, data.type, data.file_url, data.canonical_url, data.guest_url);
        }
        else if (data.type === "audio") {
            return new AudioMedia(language, image, data.download_url, data.transcript_print_url, data.trascript_text, data.transcript_url, data.audio_url, captions, data.chapters_url, !!data.has_georestriction);
        }
        else if (data.type === "htmlfragment") {
            return new HTMLMedia(language, image, data.download_url, data.content);
        }
    };
    return Media;
}());
export { Media };
var DocumentMedia = /** @class */ (function (_super) {
    __extends(DocumentMedia, _super);
    function DocumentMedia(language, posterImage, downloadGenerateURL, documentURL) {
        var _this = _super.call(this, language, posterImage, downloadGenerateURL) || this;
        _this.language = language;
        _this.posterImage = posterImage;
        _this.downloadGenerateURL = downloadGenerateURL;
        _this.documentURL = documentURL;
        return _this;
    }
    return DocumentMedia;
}(Media));
export { DocumentMedia };
var TranscriptMedia = /** @class */ (function (_super) {
    __extends(TranscriptMedia, _super);
    function TranscriptMedia(language, posterImage, downloadGenerateURL, transcriptPrintURL, transcriptText, transcriptURL) {
        var _this = _super.call(this, language, posterImage, downloadGenerateURL) || this;
        _this.language = language;
        _this.posterImage = posterImage;
        _this.downloadGenerateURL = downloadGenerateURL;
        _this.transcriptPrintURL = transcriptPrintURL;
        _this.transcriptText = transcriptText;
        _this.transcriptURL = transcriptURL;
        return _this;
    }
    TranscriptMedia.prototype.hasTranscript = function () {
        return this.transcriptURL || this.transcriptText;
    };
    return TranscriptMedia;
}(Media));
export { TranscriptMedia };
var PlayableMedia = /** @class */ (function (_super) {
    __extends(PlayableMedia, _super);
    function PlayableMedia(language, posterImage, downloadGenerateURL, transcriptPrintURL, transcriptText, transcriptURL, captions, chaptersURL) {
        var _this = _super.call(this, language, posterImage, downloadGenerateURL, transcriptPrintURL, transcriptText, transcriptURL) || this;
        _this.language = language;
        _this.posterImage = posterImage;
        _this.downloadGenerateURL = downloadGenerateURL;
        _this.transcriptPrintURL = transcriptPrintURL;
        _this.transcriptText = transcriptText;
        _this.transcriptURL = transcriptURL;
        _this.captions = captions;
        _this.chaptersURL = chaptersURL;
        return _this;
    }
    PlayableMedia.prototype.getVideoJsTracks = function () {
        // https://docs.videojs.com/tutorial-text-tracks.html#track-attributes
        var tracks = [];
        if (this.captions) {
            this.captions.forEach(function (caption) {
                tracks.push({
                    kind: "captions",
                    srclang: LanguageUtil.toCode(caption.language),
                    label: caption.language,
                    src: caption.url,
                });
            });
            if (tracks.length) {
                tracks[0].default = true;
            }
        }
        if (this.chaptersURL) {
            tracks.push({
                kind: "chapters",
                src: this.chaptersURL,
                label: "Chapters",
            });
        }
        return tracks;
    };
    return PlayableMedia;
}(TranscriptMedia));
export { PlayableMedia };
var VideoMediaFile = /** @class */ (function () {
    function VideoMediaFile(hasGeoRestriction, role, originalURL, type, primary) {
        this.hasGeoRestriction = hasGeoRestriction;
        this.role = role;
        this.originalURL = originalURL;
        this.type = type;
        this.primary = primary;
        this.showsStaticGeoRestrictionVideo = false;
    }
    VideoMediaFile.prototype.setValidatedURL = function (url) {
        this.validatedURL = url;
    };
    VideoMediaFile.prototype.getURL = function () {
        if (this.validatedURL) {
            return this.validatedURL;
        }
        return this.originalURL;
    };
    VideoMediaFile.prototype.isGeoRestrictionEvaluated = function () {
        //todo: note that once jwplayer is removed this needs changing, validatedURL is no longer ok
        return !this.hasGeoRestriction || !!this.validatedURL;
    };
    VideoMediaFile.prototype.getMediaType = function () {
        if (this.showsStaticGeoRestrictionVideo) {
            // All static videos are mp4
            return "video/mp4";
        }
        // TODO: consider other options, maybe extension check
        if (this.type === "HLS 16x9" || this.type === "HLS 4x3") {
            return "application/x-mpegURL";
        }
        else {
            return "video/mp4";
        }
    };
    VideoMediaFile.fromData = function (data) {
        return new VideoMediaFile(data.has_georestriction, data.role, data.url, data.type, data.primary);
    };
    return VideoMediaFile;
}());
export { VideoMediaFile };
var Caption = /** @class */ (function () {
    function Caption(url, language) {
        this.url = url;
        this.language = language;
    }
    return Caption;
}());
export { Caption };
var VideoMedia = /** @class */ (function (_super) {
    __extends(VideoMedia, _super);
    function VideoMedia(language, posterImage, downloadGenerateURL, transcriptPrintURL, transcriptText, transcriptURL, captions, videoFiles, is360, chaptersURL) {
        var _this = _super.call(this, language, posterImage, downloadGenerateURL, transcriptPrintURL, transcriptText, transcriptURL, captions, chaptersURL) || this;
        _this.language = language;
        _this.posterImage = posterImage;
        _this.downloadGenerateURL = downloadGenerateURL;
        _this.transcriptPrintURL = transcriptPrintURL;
        _this.transcriptText = transcriptText;
        _this.transcriptURL = transcriptURL;
        _this.captions = captions;
        _this.videoFiles = videoFiles;
        _this.is360 = is360;
        _this.chaptersURL = chaptersURL;
        _this.usedFile =
            _this.videoFiles.find(function (file) { return file.type === "HLS 16x9"; }) ||
                // Legacy files
                _this.videoFiles.find(function (file) { return file.type === "HLS 4x3"; }) ||
                // Transcoded MP4 (MP3 name is wrong in the backend)
                _this.videoFiles.find(function (file) { return file.type === "MP4 16x9"; }) ||
                _this.videoFiles.find(function (file) { return file.type === "MP3 16x9"; }) ||
                // Default, generally source file
                _this.videoFiles[0];
        if (_this.usedFile &&
            (_this.usedFile.type === "HLS 16x9" ||
                _this.usedFile.type === "HLS 4x3")) {
            _this.backup =
                // Transcoded MP4 (MP3 name is wrong in the backend)
                _this.videoFiles.find(function (file) { return file.type === "MP4 16x9"; }) ||
                    _this.videoFiles.find(function (file) { return file.type === "MP3 16x9"; });
        }
        return _this;
    }
    VideoMedia.prototype.isGeoRestrictionEvaluated = function () {
        return this.usedFile.isGeoRestrictionEvaluated();
    };
    VideoMedia.prototype.setGeoRestrictionResponse = function (checkedURL, url, errorCode) {
        var file = this.videoFiles.find(function (possibleFile) { return possibleFile.originalURL === checkedURL; });
        if (errorCode) {
            // May also need to change poster image.
            this.isAvailable = false;
            // TODO: once jwplayer is removed, we don't need this
            file.setValidatedURL(window.PBSLM.NG.CDN + "player_error_videos/" + errorCode + ".mp4");
            file.showsStaticGeoRestrictionVideo = true;
        }
        else {
            file.setValidatedURL(url);
        }
    };
    VideoMedia.prototype.getGeoRestrictedCheckURL = function () {
        return this.usedFile.originalURL;
    };
    VideoMedia.prototype.hasTranscript = function () {
        return this.transcriptText || this.transcriptURL;
    };
    VideoMedia.prototype.getVideoJsSources = function () {
        if (this.backup) {
            return [
                {
                    type: this.usedFile.getMediaType(),
                    src: this.usedFile.getURL(),
                },
                {
                    type: this.backup.getMediaType(),
                    src: this.backup.getURL(),
                },
            ];
        }
        return {
            type: this.usedFile.getMediaType(),
            src: this.usedFile.getURL(),
        };
    };
    VideoMedia.prototype.getJWPlayerPlaylist = function () {
        var tracks = this.captions.map(function (caption) {
            return {
                file: caption.url,
                kind: "captions",
                label: caption.language,
            };
        });
        if (this.chaptersURL) {
            tracks.push({
                file: this.chaptersURL,
                kind: "chapters",
            });
        }
        return {
            image: this.posterImage.itsURL,
            sources: { file: this.usedFile.getURL() },
            title: "",
            tracks: tracks,
            stereomode: this.is360 ? "monoscopic" : null,
        };
    };
    return VideoMedia;
}(PlayableMedia));
export { VideoMedia };
var HTMLMedia = /** @class */ (function (_super) {
    __extends(HTMLMedia, _super);
    function HTMLMedia(language, posterImage, downloadGenerateURL, htmlContent) {
        var _this = _super.call(this, language, posterImage, downloadGenerateURL) || this;
        _this.language = language;
        _this.posterImage = posterImage;
        _this.downloadGenerateURL = downloadGenerateURL;
        _this.htmlContent = htmlContent;
        return _this;
    }
    return HTMLMedia;
}(Media));
export { HTMLMedia };
var GenericInteractiveMedia = /** @class */ (function (_super) {
    __extends(GenericInteractiveMedia, _super);
    // Media that opens externally
    function GenericInteractiveMedia(language, posterImage, downloadGenerateURL, type, url, canonicalUrl) {
        var _this = _super.call(this, language, posterImage, downloadGenerateURL) || this;
        _this.language = language;
        _this.posterImage = posterImage;
        _this.downloadGenerateURL = downloadGenerateURL;
        _this.type = type;
        _this.url = url;
        _this.canonicalUrl = canonicalUrl;
        return _this;
    }
    return GenericInteractiveMedia;
}(Media));
export { GenericInteractiveMedia };
var LTIMedia = /** @class */ (function (_super) {
    __extends(LTIMedia, _super);
    function LTIMedia(language, posterImage, downloadGenerateURL, type, url, canonicalUrl, guestURL // no-login external link
    ) {
        var _this = _super.call(this, language, posterImage, downloadGenerateURL, type, url, canonicalUrl) || this;
        _this.language = language;
        _this.posterImage = posterImage;
        _this.downloadGenerateURL = downloadGenerateURL;
        _this.type = type;
        _this.url = url;
        _this.canonicalUrl = canonicalUrl;
        _this.guestURL = guestURL;
        return _this;
    }
    LTIMedia.prototype.getGuestURL = function (currentURL) {
        // WGHB specific format
        return this.guestURL + "?as_guest=True&next=" + currentURL;
    };
    return LTIMedia;
}(GenericInteractiveMedia));
export { LTIMedia };
var InteractiveMedia = /** @class */ (function (_super) {
    __extends(InteractiveMedia, _super);
    function InteractiveMedia(language, posterImage, downloadGenerateURL, type, url, canonicalUrl, showFlashWarning) {
        var _this = _super.call(this, language, posterImage, downloadGenerateURL, type, url, canonicalUrl) || this;
        _this.language = language;
        _this.posterImage = posterImage;
        _this.downloadGenerateURL = downloadGenerateURL;
        _this.type = type;
        _this.url = url;
        _this.canonicalUrl = canonicalUrl;
        _this.showFlashWarning = showFlashWarning;
        return _this;
    }
    return InteractiveMedia;
}(GenericInteractiveMedia));
export { InteractiveMedia };
var PointerMedia = /** @class */ (function (_super) {
    __extends(PointerMedia, _super);
    function PointerMedia(language, posterImage, downloadGenerateURL, type, url, canonicalUrl, showFlashWarning) {
        var _this = _super.call(this, language, posterImage, downloadGenerateURL, type, url, canonicalUrl) || this;
        _this.language = language;
        _this.posterImage = posterImage;
        _this.downloadGenerateURL = downloadGenerateURL;
        _this.type = type;
        _this.url = url;
        _this.canonicalUrl = canonicalUrl;
        _this.showFlashWarning = showFlashWarning;
        return _this;
    }
    return PointerMedia;
}(GenericInteractiveMedia));
export { PointerMedia };
//todo
var HTMLFragmentMedia = /** @class */ (function (_super) {
    __extends(HTMLFragmentMedia, _super);
    function HTMLFragmentMedia(language, posterImage, downloadGenerateURL, htmlContent) {
        var _this = _super.call(this, language, posterImage, downloadGenerateURL) || this;
        _this.language = language;
        _this.posterImage = posterImage;
        _this.downloadGenerateURL = downloadGenerateURL;
        _this.htmlContent = htmlContent;
        return _this;
    }
    return HTMLFragmentMedia;
}(Media));
export { HTMLFragmentMedia };
var ImageMedia = /** @class */ (function (_super) {
    __extends(ImageMedia, _super);
    function ImageMedia(language, posterImage, downloadGenerateURL, largeImageURL, ARIADescription, canonicalUrl) {
        var _this = _super.call(this, language, posterImage, downloadGenerateURL) || this;
        _this.language = language;
        _this.posterImage = posterImage;
        _this.downloadGenerateURL = downloadGenerateURL;
        _this.largeImageURL = largeImageURL;
        _this.ARIADescription = ARIADescription;
        _this.canonicalUrl = canonicalUrl;
        return _this;
    }
    return ImageMedia;
}(Media));
export { ImageMedia };
var AudioMedia = /** @class */ (function (_super) {
    __extends(AudioMedia, _super);
    function AudioMedia(language, posterImage, downloadGenerateURL, transcriptPrintURL, transcriptText, transcriptURL, audioURL, captions, chaptersURL, hasGeoRestriction) {
        var _this = _super.call(this, language, posterImage, downloadGenerateURL, transcriptPrintURL, transcriptText, transcriptURL, captions, chaptersURL) || this;
        _this.language = language;
        _this.posterImage = posterImage;
        _this.downloadGenerateURL = downloadGenerateURL;
        _this.transcriptPrintURL = transcriptPrintURL;
        _this.transcriptText = transcriptText;
        _this.transcriptURL = transcriptURL;
        _this.audioURL = audioURL;
        _this.captions = captions;
        _this.chaptersURL = chaptersURL;
        _this.hasGeoRestriction = hasGeoRestriction;
        _this.validatedURL = null;
        return _this;
    }
    AudioMedia.prototype.getTracks = function () {
        //implement captions ?
        if (this.chaptersURL) {
            return [
                {
                    file: this.chaptersURL,
                    kind: "chapters",
                },
            ];
        }
        return [];
    };
    AudioMedia.prototype.isGeoRestrictionEvaluated = function () {
        if (!this.hasGeoRestriction) {
            return true;
        }
        // based on the 2 possible outcomes, rather than having another isEvaluated flag
        return !!this.validatedURL || !this.isAvailable;
    };
    AudioMedia.prototype.getURL = function () {
        if (this.validatedURL) {
            return this.validatedURL;
        }
        return this.audioURL;
    };
    AudioMedia.prototype.getGeoRestrictedCheckURL = function () {
        return this.audioURL;
    };
    AudioMedia.prototype.setGeoRestrictionResponse = function (checkedURL, url, errorCode) {
        if (errorCode) {
            this.isAvailable = false;
        }
        this.validatedURL = url;
    };
    AudioMedia.prototype.getVideoJsSource = function () {
        return { type: "audio/mp3", src: this.getURL() };
    };
    return AudioMedia;
}(PlayableMedia));
export { AudioMedia };
